import {DeliveryStandard, ReportType} from "../../../api/ApiTypes.ts";

// takes an order or a quote
export const isUad36Order = (orderOrQuote: { deliveryStandard: DeliveryStandard | null }): boolean => {
    return orderOrQuote.deliveryStandard === DeliveryStandard.M36;
};

export const getReportTypeDisplayName = (
    reportType: ReportType | null | undefined,
    deliveryStandard: DeliveryStandard | null
): string => {
    return deliveryStandard === DeliveryStandard.M36 && reportType?.threeSixProductName
        ? reportType.threeSixProductName
        : reportType?.productDescription ?? "";
};
